module.exports = __webpack_public_path__ + "static/img/code.9ef18f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/code.png
// module id = EF7e
// module chunks = 2